// Cyprus payroll configuration — 2026 rates
// Sources: Cyprus Tax Department (Income Tax Law, 2026 reform),
// Social Insurance Services, GESY/HIO (General Healthcare System Law).
// These are reviewed periodically — recheck against official notices before relying on them.

export const TAX_YEAR = 2026;

// Progressive income tax bands (annual, EUR)
export const INCOME_TAX_BANDS = [
  { upTo: 22000, rate: 0 },
  { upTo: 32000, rate: 0.20 },
  { upTo: 42000, rate: 0.25 },
  { upTo: 72000, rate: 0.30 },
  { upTo: Infinity, rate: 0.35 },
];

// Social Insurance
export const SOCIAL_INSURANCE = {
  employeeRate: 0.088,
  employerRate: 0.088,
  annualCeiling: 68904,
};

// GESY / GHS (General Healthcare System)
export const GESY = {
  employeeRate: 0.0265,
  employerRate: 0.0290,
  annualCeiling: 180000,
};

// Employer-only contributions
export const EMPLOYER_EXTRA = {
  redundancyFund: 0.012,            // 1.2%, follows SI ceiling
  humanResourceDevelopment: 0.005,  // 0.5%, follows SI ceiling
  socialCohesionFund: 0.02,         // 2%, uncapped
};